import React, { useState } from 'react';
import { PaginationListType } from '../../../Types/PaginationParams';
import { promptService } from '../../../Services/promptService';
import { modelService } from '../../../Services/modelService';
import { connectorService } from '../../../Services/connectorService';
import { Button } from '../../Utility/Button';
import Input from '../../Utility/FormElements/Input';
import AdminContainer from '../../Utility/AdminContainer';
import useGroup from '../../../Hooks/useGroup';
import AdminBox from '../../Utility/AdminBox';
import { Model, Prompt, PromptFunction } from '../../../Types';
import AdminBoxHeadline from '../../Utility/AdminBoxHeadline';
import { ArrowDownIcon, ArrowRightIcon } from '@phosphor-icons/react';
import ConnectorItem from '../Prompt/components/ConnectorItem';
import PaginatedView from '../../Utility/PaginatedView';

function Group() {
    const {
        GroupActions,
        groupIdentifier,
        group,
        selectedPromptIdentifiers,
        maxCosts,
        title,
        selectedModelIdentifiers,
        functions,
        selectedFunctionIdentifiers,
        groupLoaded,
        usersLoaded,
        handleNavigate,
        i18n,
    } = useGroup();

    const [showPrompts, setShowPrompts] = useState(false);
    const [showUsers, setShowUsers] = useState(false);
    const [showModels, setShowModels] = useState(false);
    const [showFunctions, setShowFunctions] = useState(false);

    const handleSave = () => {
        GroupActions.handleSave();
    };

    const handleMaxCostChange = (value: number) => {
        GroupActions.handleMaxCostChange(value);
    };

    const handleTitleChange = (value: string) => {
        GroupActions.handleTitleChange(value);
    };

    const handlePromptCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        GroupActions.handlePromptCheckboxChange(event);
    };

    const handleModelCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        GroupActions.handleModelCheckboxChange(event);
    };

    const handleFunctionCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        GroupActions.handleFunctionCheckboxChange(event);
    };

    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <AdminBox contentLoaded={groupLoaded}>
                            <AdminBoxHeadline
                                headLine={i18n.translate({
                                    id:
                                        groupIdentifier === 'new' || group.mandant === 'default'
                                            ? 'newGroup'
                                            : 'editGroup',
                                    sourceName: 'Group',
                                })}
                                subLine={
                                    groupIdentifier === 'new' || group.mandant === 'default' ? undefined : group.title
                                }
                            />

                            <h5>{i18n.translate({ id: 'title.settings', sourceName: 'Group' })}</h5>

                            {(groupIdentifier === 'new' || group.mandant === 'default') && (
                                <div>
                                    <label className="block mb-2">
                                        {i18n.translate({ id: 'title.name', sourceName: 'Group' })}
                                    </label>
                                    <Input
                                        inputType="text"
                                        value={title || ''}
                                        onChange={handleTitleChange}
                                        placeholder="Name..."
                                    />
                                </div>
                            )}
                            <div>
                                <label htmlFor="maxCosts" className="block mb-2">
                                    {i18n.translate({ id: 'title.costsMonth', sourceName: 'Group' })}
                                </label>
                                <Input
                                    inputType="number"
                                    value={maxCosts ?? '0'}
                                    onChange={handleMaxCostChange}
                                    inputProps={{ min: 0, step: 0.1 }}
                                    id="maxCosts"
                                />
                            </div>
                        </AdminBox>

                        <AdminBox contentLoaded={usersLoaded} classString="relative">
                            <h5
                                className={`relative pl-[40px] leading-[30px] cursor-pointer`}
                                onClick={() => {
                                    setShowUsers(!showUsers);
                                }}
                            >
                                <div className="absolute w-fit h-fit bottom-0 left-0 m-auto">
                                    <button
                                        className="rounded-full h-[25px] md:h-[30px] w-[25px] md:w-[30px] transition-all duration-100 text-chatInput-sendButtonColor bg-chatInput-sendButtonBackground hover:bg-chatInput-sendButtonBackground-hover border-none flex items-center justify-center"
                                        title="Benutzer anzeigen/ausblenden"
                                    >
                                        <ArrowDownIcon
                                            size={20}
                                            style={{
                                                transform: showUsers ? 'rotate(-180deg)' : 'rotate(0deg)',
                                                transition: 'transform 0.3s ease',
                                            }}
                                        />
                                    </button>
                                </div>
                                {i18n.translate({ id: 'title.users', sourceName: 'Group' })}
                            </h5>
                            <div
                                className={`${
                                    showUsers ? 'max-h-[2000px]' : 'max-h-0'
                                } overflow-y-hidden transition-all duration-[300ms]`}
                            >
                                <PaginatedView
                                    listType={PaginationListType.Users}
                                    listClassName="gap-3 flex flex-col pt-5"
                                    itemsFunction={GroupActions.getUsersByGroupWrapper}
                                    itemsPerPage={15}
                                    renderItem={(user: any, index) => (
                                        <div className="grid grid-cols-[minmax(157px,300px),minmax(157px,1fr)] cursor-pointer gap-3 py-2 px-4 rounded-lg hover:bg-chatlist-item-background-hover">
                                            <div className="w-full flex items-center text-ellipsis overflow-hidden">
                                                <span>{user.givenName + ' ' + user.familyName}</span>
                                            </div>
                                            <div className="flex gap-1 justify-end items-center">
                                                <Button
                                                    variant="secondaryRound"
                                                    onClick={() => {
                                                        handleNavigate(`/admin/users/${user.identifier}`);
                                                    }}
                                                >
                                                    <ArrowRightIcon size={20} />
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                >
                                    {({ list, filter }) => (
                                        <>
                                            {filter}
                                            {list}
                                        </>
                                    )}
                                </PaginatedView>
                            </div>
                        </AdminBox>
                    </div>
                    <div>
                        <AdminBox contentLoaded={groupLoaded} classString="relative">
                            <h5
                                className={`relative pl-[40px] leading-[30px] cursor-pointer`}
                                onClick={() => {
                                    setShowPrompts(!showPrompts);
                                }}
                            >
                                <div className="absolute w-fit h-fit bottom-0 left-0 m-auto">
                                    <button
                                        className="rounded-full h-[25px] md:h-[30px] w-[25px] md:w-[30px] transition-all duration-100 text-chatInput-sendButtonColor bg-chatInput-sendButtonBackground hover:bg-chatInput-sendButtonBackground-hover border-none flex items-center justify-center"
                                        title="Prompts anzeigen/ausblenden"
                                    >
                                        <ArrowDownIcon
                                            size={20}
                                            style={{
                                                transform: showPrompts ? 'rotate(-180deg)' : 'rotate(0deg)',
                                                transition: 'transform 0.3s ease',
                                            }}
                                        />
                                    </button>
                                </div>
                                {i18n.translate({ id: 'title.prompts', sourceName: 'Group' })}
                            </h5>
                            <div
                                className={`${
                                    showPrompts ? 'max-h-[2000px]' : 'max-h-0'
                                } overflow-y-hidden transition-all duration-[300ms]`}
                            >
                                <PaginatedView
                                    listType={PaginationListType.Assistants}
                                    itemsFunction={promptService.getPromptsByPage}
                                    itemsPerPage={10}
                                    renderItem={(prompt: Prompt, index: number) => (
                                        <ConnectorItem
                                            key={prompt.identifier}
                                            identifier={prompt.identifier}
                                            title={prompt.name}
                                            image={prompt.image}
                                            useAvatar={true}
                                            handleChangeFunction={() =>
                                                handlePromptCheckboxChange({
                                                    target: {
                                                        checked: !(selectedPromptIdentifiers ?? []).includes(prompt.identifier),
                                                        name: prompt.identifier,
                                                    },
                                                } as React.ChangeEvent<HTMLInputElement>)
                                            }
                                            isActive={(selectedPromptIdentifiers ?? []).includes(prompt.identifier)}
                                        />
                                    )}
                                    listClassName="gap-3 flex flex-col pt-5"
                                    filterClassName="mt-4"
                                >
                                    {({ list, filter }) => (
                                        <>
                                            {filter}
                                            {list}
                                        </>
                                    )}
                                </PaginatedView>
                            </div>
                        </AdminBox>

                        <AdminBox contentLoaded={groupLoaded} classString="relative">
                            <h5
                                className={`relative pl-[40px] leading-[30px] cursor-pointer`}
                                onClick={() => {
                                    setShowModels(!showModels);
                                }}
                            >
                                <div className="absolute w-fit h-fit bottom-0 left-0 m-auto">
                                    <button
                                        className="rounded-full h-[25px] md:h-[30px] w-[25px] md:w-[30px] transition-all duration-100 text-chatInput-sendButtonColor bg-chatInput-sendButtonBackground hover:bg-chatInput-sendButtonBackground-hover border-none flex items-center justify-center"
                                        title="KI-Modelle anzeigen/ausblenden"
                                    >
                                        <ArrowDownIcon
                                            size={20}
                                            style={{
                                                transform: showModels ? 'rotate(-180deg)' : 'rotate(0deg)',
                                                transition: 'transform 0.3s ease',
                                            }}
                                        />
                                    </button>
                                </div>
                                {i18n.translate({ id: 'title.models', sourceName: 'Group' })}
                            </h5>
                            <div
                                className={`${
                                    showModels ? 'max-h-[2000px]' : 'max-h-0'
                                } overflow-y-hidden transition-all duration-[300ms]`}
                            >
                                <PaginatedView
                                    listType={PaginationListType.Models}
                                    itemsFunction={modelService.getModelsByPage}
                                    itemsPerPage={10}
                                    renderItem={(model: Model, index: number) => (
                                        <ConnectorItem
                                            key={model.identifier}
                                            identifier={model.identifier}
                                            title={model.title}
                                            image={model.image}
                                            handleChangeFunction={() =>
                                                handleModelCheckboxChange({
                                                    target: {
                                                        checked: !(selectedModelIdentifiers ?? []).includes(model.identifier),
                                                        name: model.identifier,
                                                    },
                                                } as React.ChangeEvent<HTMLInputElement>)
                                            }
                                            isActive={(selectedModelIdentifiers ?? []).includes(model.identifier)}
                                        />
                                    )}
                                    listClassName="gap-3 flex flex-col pt-5"
                                    filterClassName="mt-4"
                                >
                                    {({ list, filter }) => (
                                        <>
                                            {filter}
                                            {list}
                                        </>
                                    )}
                                </PaginatedView>
                            </div>
                        </AdminBox>

                        {functions && (
                            <AdminBox contentLoaded={groupLoaded} classString="relative">
                                <h5
                                    className={`relative pl-[40px] leading-[30px] cursor-pointer`}
                                    onClick={() => {
                                        setShowFunctions(!showFunctions);
                                    }}
                                >
                                    <div className="absolute w-fit h-fit bottom-0 left-0 m-auto">
                                        <button
                                            className="rounded-full h-[25px] md:h-[30px] w-[25px] md:w-[30px] transition-all duration-100 text-chatInput-sendButtonColor bg-chatInput-sendButtonBackground hover:bg-chatInput-sendButtonBackground-hover border-none flex items-center justify-center"
                                            title="Konnektoren anzeigen/ausblenden"
                                        >
                                            <ArrowDownIcon
                                                size={20}
                                                style={{
                                                    transform: showFunctions ? 'rotate(-180deg)' : 'rotate(0deg)',
                                                    transition: 'transform 0.3s ease',
                                                }}
                                            />
                                        </button>
                                    </div>
                                    {i18n.translate({ id: 'title.functions', sourceName: 'Group' })}
                                </h5>
                                <div
                                    className={`${
                                        showFunctions ? 'max-h-[2000px]' : 'max-h-0'
                                    } overflow-y-hidden transition-all duration-[300ms]`}
                                >
                                    <PaginatedView
                                        listType={PaginationListType.Connectors}
                                        itemsFunction={connectorService.getPromptFunctionsByPage}
                                        itemsPerPage={10}
                                        renderItem={(promptFunction: PromptFunction, index: number) => (
                                            <ConnectorItem
                                                key={promptFunction.identifier}
                                                title={promptFunction.title ?? ''}
                                                image={promptFunction.image}
                                                identifier={promptFunction.identifier}
                                                handleChangeFunction={() => {
                                                    handleFunctionCheckboxChange({
                                                        target: {
                                                            checked: !(selectedFunctionIdentifiers ?? []).includes(
                                                                promptFunction.identifier,
                                                            ),
                                                            name: promptFunction.identifier,
                                                        },
                                                    } as React.ChangeEvent<HTMLInputElement>);
                                                }}
                                                isActive={(selectedFunctionIdentifiers ?? []).includes(promptFunction.identifier)}
                                            />
                                        )}
                                        listClassName="gap-3 flex flex-col pt-5"
                                        filterClassName="mt-4"
                                    >
                                        {({ list, filter }) => (
                                            <>
                                                {filter}
                                                {list}
                                            </>
                                        )}
                                    </PaginatedView>
                                </div>
                            </AdminBox>
                        )}
                    </div>
                </div>
                <div className="mt-4 text-right">
                    <Button variant="primary" onClick={handleSave}>
                        {i18n.translate({ id: 'save', sourceName: 'Main' })}
                    </Button>
                </div>
            </AdminContainer>
        </div>
    );
}

export default Group;
